const settings = {
	infiniteAttempts: true,
	limitAttemptSpeed: true,
	showStarProgress: true,
	canEarnStarsOnTrialSubmission: true,
	showMessageOnStarEarned: true,
	neverGiveUp: true,
	canReplayProblem: true,
	noProblemHistory: true,
	staticMaxStars: true,
};

const getLastAvailableIndex = function(result) {
	return result.problems.length - 1;
};

const getTrialXP = function(result) {
	return 15;
};

const getSetProgressInfo = function(result) {
	return {
		viewType: "standard",
		data: {},
	};
};

module.exports = {
	settings,
	getLastAvailableIndex,
	getTrialXP,
	getSetProgressInfo,
};
